<fieldset
  class="app-loading-overlay__content"
  [attr.inert]="loading() || null"
  [disabled]="loading() || null"
  [style.opacity]="backdrop() && loading() ? 0.3 : null"
>
  <ng-content />
</fieldset>

@if (loading()) {
  <div class="app-loading-overlay__spinner">
    <app-progress-spinner />
  </div>
}
